// extracted by mini-css-extract-plugin
module.exports = {"locationId":"index_locationId_1uEcK"};